import React from "react";
import styled from "styled-components";

import FeeCards from "./FeeCards";
import Controls from "./Controls";
import UsagePaymentsChart from "./UsagePaymentsChart";
import ClaimTypesChart from "./ClaimTypesChart";
import CostsTable from "./CostsTable";
import commonStyles from "css/common.module.css";

const Container = styled.div.attrs({ className: "analytics-dashboard" })`
  max-width: 100%;

  .dashboard__head {
    background: ${props => props.theme.colors.white};
    box-shadow: 0 0 20px 0 rgba(109, 120, 129, 0.16);
    display: flex;
    flex-direction: column;
  }
  .dashboard__head .title {
    font-size: 19px;
    font-weight: bold;
    margin: 0 0 24px;
  }
  @media (min-width: 1550px) {
    .dashboard__head {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    }
    .dashboard__head .title {
      margin: 0 24px 0 0;
    }

    .charts {
      display: flex;
      max-width: 100%;
    }
    .charts__usage {
      width: 70%;
    }
    .charts__claims {
      flex: 1;
      max-width: 25%;
      margin: 24px 24px 0 0;
    }
  }
`;

const AnalyticsDashboard = () => {
  return (
    <Container className={`${commonStyles.page} pb`}>
      <div className="dashboard__head p">
        <h6 className="h6 title">Fees Reporting and Analytics</h6>
        <Controls />
      </div>

      <FeeCards className="mt mx" />

      <div className="charts">
        <UsagePaymentsChart className="mt mx charts__usage" />
        <ClaimTypesChart className="mt mx charts__claims" />
      </div>

      <CostsTable className="mt mx" />
    </Container>
  );
};

export default AnalyticsDashboard;
